import React from "react";
import { colors } from "@ui/Theme";
import t from "../../../../../../../../../i18n";
import type { BlockCommentImportT } from "../../../../../../schema/block/comment";
import EditBoxLine from "@ui/IconV2/react/EditBoxLine";

export const icon = () => <EditBoxLine size="l" color={colors.carbon800} />;

export const title = t("project.dashboard.block.template.comment.title");

export const description = null;

export const block: Omit<BlockCommentImportT, "dashboardId" | "position"> = {
  kind: "COMMENT",
  data: "",
};
